import { RunGroupFormValues } from "@features/run/RunGroupDialog/RunGroupForm"
import { TextField } from "@mui/material"
import { getErrorMessage } from "@utils/form"
import { Controller, useFormContext } from "react-hook-form"

export const RunGroupFieldName = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<RunGroupFormValues>()

  return (
    <Controller
      name="run_name"
      control={control}
      render={({ field }) => (
        <TextField
          error={Boolean(errors[field.name])}
          helperText={getErrorMessage(errors, field.name)}
          label="Name of run"
          variant="standard"
          sx={{ spacing: 2 }}
          {...field}
        />
      )}
    />
  )
}
